

export class StatDoc {
    status : string
    qty: number
}